import { ColDef, ColGroupDef } from 'ag-grid-community';
import { JobCellComponent } from 'src/app/shared/ag-grid-cell-renderers/job-cell.component';
import { PersonCellComponent } from 'src/app/shared/ag-grid-cell-renderers/person-cell.component';
import { JobsTableCellRendererComponent } from 'src/app/shared/jobs-table-cell-renderer/jobs-table-cell-renderer.component';

export const defaultColDef: ColDef = {
  sortable: true,
  resizable: true,
  flex: 1,
  minWidth: 100,
  suppressHeaderMenuButton: true,
};

export const getPeopleFancyGridColumnDefs = (
  gridType: 'full' | 'sample'
): (ColDef | ColGroupDef)[] => [
  {
    headerName: 'Person Info',
    cellRenderer: PersonCellComponent,
    minWidth: gridType === 'sample' ? 220 : 350,
    maxWidth: 380,
    cellRendererParams: {
      showName: gridType === 'full',
      showLinkedin: gridType === 'full',
      showLocation: gridType === 'full',
    },
  },
  {
    headerName: 'Current Job',
    field: 'position',
    cellRenderer: JobCellComponent,
    autoHeight: true,
    minWidth: 250,
    maxWidth: 290,
    cellRendererParams: {
      suppressCount: true,
      showEndDate: false,
      oneColLayout: true,
    },
  },
  {
    headerName: 'Job History',
    cellRenderer: JobsTableCellRendererComponent,
    minWidth: 500,
    flex: 2,
    filter: false,
    sortable: false,
    autoHeight: true,
  },
];
